import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "./client";

export interface UiSettings {
  calm_transcripts: boolean;
}

// Polled so an admin toggle propagates to family sessions within ~30s.
export function useUiSettings() {
  return useQuery<UiSettings>({
    queryKey: ["ui-settings"],
    queryFn: () => apiFetch<UiSettings>("/api/dev/ui-settings"),
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}

export function useSaveUiSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (settings: UiSettings) =>
      apiFetch<UiSettings & { ok: boolean }>("/api/dev/ui-settings", {
        method: "PUT",
        body: JSON.stringify(settings),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["ui-settings"] });
    },
  });
}
